<template>
  <b-overlay v-if="menu.content" :show="isLoading">
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }">
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item>LINE 主控台</b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'RichMenu' }">圖文選單</b-breadcrumb-item>
            <b-breadcrumb-item active>{{ title }}</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <div class="row mb-2 align-items-center">
        <div class="col-12 col-xl-2">
          <h4 class="font-weight-bold">{{ title }}</h4>
        </div>
      </div>

      <h5>基本設定</h5>

      <div class="form-group row">
        <label class="col-sm-2 col-form-label text-right">* 標題</label>
        <div class="col-sm-10">
          <b-form-input
            type="text"
            class="form-control"
            placeholder="輸入標題"
            :state="v$.menu.title.$error ? false : null"
            maxlength="100"
            required
            v-model="menu.title"
            :disabled="isReadonly"
          />
          <b-form-invalid-feedback :state="!v$.menu.title.$error">
            此欄位為必填
          </b-form-invalid-feedback>
        </div>
      </div>

      <div class="form-group form-row">
        <label class="col-sm-2 col-form-label text-right">* 開始時間</label>
        <div class="col-sm-10">
          <div class="row">
            <div class="col-sm-3">
              <datepicker
                placeholder="日期"
                v-model="menu.start_at.date"
                bootstrap-styling
                format="yyyy-MM-dd"
                :language="zh"
                :input-class="v$.menu.start_at.date.$error ? 'is-invalid' : ''"
                :disabled="isReadonly"
              ></datepicker>
              <b-form-invalid-feedback :state="!v$.menu.start_at.date.$error">
                此欄位為必填
              </b-form-invalid-feedback>
            </div>
            <div class="col-sm-3 timepicker">
              <vue-timepicker
                :input-class="`${
                  v$.menu.start_at.time.HH.$error ||
                  v$.menu.start_at.time.mm.$error
                    ? 'is-invalid'
                    : ''
                } form-control`"
                v-model="menu.start_at.time"
                hide-clear-button
                :disabled="isReadonly"
              ></vue-timepicker>
              <b-form-invalid-feedback
                :state="
                  !v$.menu.start_at.time.HH.$error &&
                  !v$.menu.start_at.time.mm.$error
                "
              >
                此欄位為必填
              </b-form-invalid-feedback>
            </div>
          </div>
          <div class="row" v-if="v$.startAt.$error">
            <div class="col-sm-12">
              <small class="text-danger">{{ v$.startAt.$errors[0].$message }}</small>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group form-row">
        <label class="col-sm-2 col-form-label text-right">* 結束時間</label>
        <div class="col-sm-10">
          <div class="row">
            <div class="col-sm-3">
              <datepicker
                placeholder="日期"
                v-model="menu.end_at.date"
                bootstrap-styling
                format="yyyy-MM-dd"
                class="flex-fill"
                :language="zh"
                :input-class="v$.menu.end_at.date.$error ? 'is-invalid' : ''"
                :disabled="isReadonly"
              ></datepicker>
              <b-form-invalid-feedback :state="!v$.menu.end_at.date.$error">
                此欄位為必填
              </b-form-invalid-feedback>
            </div>
            <div class="col-sm-3 timepicker">
              <vue-timepicker
                :input-class="`${
                  v$.menu.end_at.time.HH.$error || v$.menu.end_at.time.mm.$error
                    ? 'is-invalid'
                    : ''
                } form-control`"
                v-model="menu.end_at.time"
                hide-clear-button
                :disabled="isReadonly"
              ></vue-timepicker>
              <b-form-invalid-feedback
                :state="
                  !v$.menu.end_at.time.HH.$error &&
                  !v$.menu.end_at.time.mm.$error
                "
              >
                此欄位為必填
              </b-form-invalid-feedback>
            </div>
          </div>
          <div class="row" v-if="v$.endAt.$error">
            <div class="col-sm-12">
              <small class="text-danger" v-for="error in v$.endAt.$errors" :key="error.$uid">
                {{ error.$message }}<br/>
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-2 col-form-label text-right pr-0"
          ><span v-b-tooltip.hover title="初始會看到的選單"
            >預設選單</span
          ></label
        >
        <div class="col-sm-10">
          <b-form-radio-group
            class="mt-2"
            v-model="menu.is_default"
            :options="[
              { text: '是', value: true },
              { text: '否', value: false },
            ]"
            :disabled="isReadonly"
          ></b-form-radio-group>
        </div>
      </div>

      <hr />

      <div class="d-flex">
        <div class="mr-4">
          <div v-if="menu.content.name !== 'custom'" class="preview-popover custom-preview-popover mb-2">
            <div class="preview-icon"></div>
            <div class="flex-fill">
              <div>框選處為可點擊的範圍</div>
              <div>(設定使用者點擊後觸發的內容)</div>
            </div>
            <div class="preview-popover__nub"></div>
          </div>
          <div>預覽</div>
          <div class="position-relative">
          <Preview
            id="customPreview"
            ref="preview"
            :image-url="imageFile || menu.image_url"
            :content="menu.content"
              :is-customized-template="isCustomizedTemplate"
            :is-customing="isCustoming"
            @is-customing="(val) => isCustoming = val"
            @custom-save="customSave"
          ></Preview>
            <button v-if="showPreviewPopover" class="close-button position-absolute"
              @click="() => showPreviewPopover = false">
              <img src="@/assets/images/close.svg" />
            </button>
            <div v-if="showPreviewPopover" class="preview-popover custom-preview-popover position-absolute mx-1"
              :style="{ bottom: '50%' }">
              <img src="@/assets/images/move.svg">
              <div class="ml-1">拖曳游標</div>
              <div class="preview-icon"></div>
              <div class="ml-1">建立 使用者 "點擊後" 觸發的區塊範圍</div>
              <div class="preview-popover__nub"></div>
            </div>
            <SpotlightHole :target="'#customPreview'" :visible="showPreviewPopover"
              :padding="{ top: 28, bottom: 4, right: 4, left: 4 }" :radius="4" :backdropOpacity="0.6" :zIndex="9999" />
          </div>
        </div>
        <div class="flex-fill">
          <h5>內容設定</h5>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">版型</label>
            <div class="col-sm-10">
              <b-button variant="outline-primary" v-b-modal.modal-template :disabled="isReadonly">選擇</b-button>

              <b-modal
                v-if="menu.content"
                id="modal-template"
                class="modal-template"
                centered
                hide-footer
              >
                <template #modal-title>
                  <div>選擇版型</div>
                  <div style="color: #45a9f8; font-size: 0.8rem;">* 如欲使用 切換圖文選單 功能，請選擇 自訂版型</div>
                </template>
                <div class="h5">大型</div>
                <div>適合顯示版面較大或項目較多的圖文選單。</div>
                <small>圖片尺寸建議：2500px × 1686px ／ 1200px × 810px ／ 800px × 540px</small>
                <div class="d-flex flex-wrap justify-content-start mt-3">
                  <div class="template template-big p-2" v-for="(t, tdx) in menuBigTemplate" :key="tdx">
                    <button v-if="t.areas.length > 0" :class="`btn btn-link border border-${
                        templateIndex == tdx ? 'success' : 'secondary'
                      } rounded-0`" @click="switchTemplate(t, tdx)">
                      <div
                        v-for="(a, adx) in t.areas" :key="adx"
                        :class="`action border border-${ templateIndex == tdx ? 'success' : 'secondary' }`"
                        :style="{
                          left: `${(a.bounds.x / t.size.width) * 100}%`,
                          top: `${(a.bounds.y / t.size.height) * 100}%`,
                          width: `${(a.bounds.width / t.size.width) * 100}%`,
                          height: `${
                            (a.bounds.height / t.size.height) * 100
                          }%`,
                        }"
                      >
                      </div>
                    </button>
                    <div v-else class="d-flex align-items-center position-relative">
                      <button
                        :class="`btn btn-link border border-${templateIndex == tdx ? 'success' : 'secondary' } rounded-0`"
                        @click="switchTemplate(t, tdx)">
                        <div
                          :class="`action border border-${templateIndex == tdx ? 'success' : 'secondary' }`"
                          class="d-flex justify-content-center align-items-center"
                          :style="{ left: 0, top: 0, width: '100%', height: '100%' }"
                        >
                          自訂
                        </div>
                      </button>
                      <img src="@/assets/images/question.png" class="hint-img" alt="自訂說明" @click="() => showCustomTemplateHint = true" />
                    </div>
                  </div>
                </div>

                <div class="h5 mt-3">小型</div>
                <div>適合顯示版面較小或項目較少的圖文選單。</div>
                <small>圖片尺寸建議：2500px × 843px ／ 1200px × 405px ／ 800px ×
                  270px</small>
                <div class="d-flex flex-wrap justify-content-start mt-3">
                  <div class="template template-small p-2" v-for="(t, tdx) in menuSmallTemplate" :key="tdx">
                    <button v-if="t.areas.length > 0"
                      :class="`btn btn-link border border-${ templateIndex == tdx + menuBigTemplate.length ? 'success' : 'secondary' } rounded-0`"
                      @click="switchTemplate(t, tdx + menuBigTemplate.length)">
                      <div
                        :class="`action border border-${ templateIndex == tdx + menuBigTemplate.length ? 'success' : 'secondary' }`"
                        v-for="(a, adx) in t.areas" :key="adx" :style="{
                          left: `${(a.bounds.x / t.size.width) * 100}%`,
                          top: `${(a.bounds.y / t.size.height) * 100}%`,
                          width: `${(a.bounds.width / t.size.width) * 100}%`,
                          height: `${
                            (a.bounds.height / t.size.height) * 100
                          }%`,
                        }"></div>
                    </button>
                    <div v-else class="d-flex align-items-center position-relative">
                      <button
                        :class="`btn btn-link border border-${ templateIndex == tdx + menuBigTemplate.length ? 'success' : 'secondary' } rounded-0`"
                        @click="switchTemplate(t, tdx + menuBigTemplate.length)">
                        <div :class="`action border border-${ templateIndex == tdx ? 'success' : 'secondary' }`"
                          class=" d-flex justify-content-center align-items-center "
                          :style="{ left: 0, top: 0, width: '100%', height: '100%' }">
                          自訂
                        </div>
                      </button>
                      <img src="@/assets/images/question.png" class="hint-img" alt="自訂說明" @click="() => showCustomTemplateHint = true" />
                    </div>
                  </div>
                </div>
              </b-modal>

              <b-modal id="modal-template-custom-hint" v-model="showCustomTemplateHint" centered hide-footer>
                <template #modal-title>
                  <div class="pt-2 font-weight-bold" style="font-size: 1rem;">自訂版型：任意拖曳框選處，即為可點擊範圍</div>
                </template>
                <div style="font-size: 0.8rem;">
                  <div class="font-weight-bold mb-1">舉例：如欲使用【切換圖文選單】功能</div>
                  <div>➊ 選擇 "自訂" 版型，上傳圖片後先儲存草稿 (* 欲切換 2 個圖檔，需新增 2 筆圖文選單)。</div>
                  <div>➋ 編輯先前存入草稿的圖文選單，逐一拖曳游標，建立點擊觸發區塊。</div>
                  <div>➌ 類型點選【切換圖文選單】，並選擇要顯示的圖文選單標題。</div>
                </div>
              </b-modal>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">圖片</label>
            <div class="col-sm-10 image-selector">
              <div
                class="image"
                v-if="imageFile || menu.image_url"
                :style="{
                  aspectRatio: `${menu.content.size.width}/${menu.content.size.height}`,
                }"
              >
                <img
                  class="img-fluid"
                  :src="imageFile != null ? imageFile : menu.image_url"
                />
                <button
                  class="btn btn-danger"
                  type="button"
                  @click="imageFile = menu.image_url = null"
                >
                  <i class="fa fa-times m-0" />
                </button>
              </div>
              <div
                class="selector"
                :style="{
                  aspectRatio: `${menu.content.size.width}/${menu.content.size.height}`,
                }"
                v-else
              >
                <ImageSelector
                  @input="selectImage"
                  :aspect-ratio="
                    menu.content.size.width / menu.content.size.height
                  "
                  class="
                    border
                    h-100
                    d-flex
                    justify-content-center
                    align-items-center
                  "
                  :class="{ 'border-danger': v$.imageFile.$error }"
                  :show-error="v$.imageFile.$error"
                >
                  <template #trigger="{ openFileSelector }">
                    <button class="btn s-trigger-btn" @click="openFileSelector">
                      <i class="fa fa-plus"></i> 圖片
                    </button>
                  </template>
                  <template #content>
                    <small class="text-center mb-2"
                      >｜檔案格式：JPG、JPEG、PNG｜檔案大小：1MB 以下</small
                    >
                  </template>
                </ImageSelector>
                <b-form-invalid-feedback :state="!v$.imageFile.$error">
                  請選取圖片
                </b-form-invalid-feedback>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-form-label">編輯欄位
              <small v-if="menu.content.name == 'custom'" :class="!isCustoming && 'text-muted'">左方預覽區，點擊 "套用自訂欄位" 完成後可進行內容編輯</small>
            </label>
            <b-card
              v-for="(i, idx) in menu.content.areas"
              class="mb-2 shadow-none"
              no-body
              :key="idx"
            >
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                  block
                  v-b-toggle="`accordion-${idx}`"
                  variant="link"
                  class="
                    text-left
                    d-flex
                    justify-content-between
                    text-decoration-none
                  "
                >
                  {{ String.fromCharCode(65 + idx) }}

                  <i class="fa" aria-hidden="true"></i>
                </b-button>
              </b-card-header>
              <b-collapse
                :id="`accordion-${idx}`"
                visible
                accordion="accordion"
              >
                <b-card-body>
                  <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-right">類型</label>
                    <div class="col-sm-10">
                      <b-select v-model="i.action.type" :disabled="isReadonly">
                        <b-select-option value="null">請選擇</b-select-option>
                        <b-select-option value="uri">連結</b-select-option>
                        <b-select-option value="message">文字訊息</b-select-option>
                        <b-select-option value="richmenuswitch">切換圖文選單</b-select-option>
                        <b-select-option value="tel">電話</b-select-option>
                      </b-select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="offset-sm-2 col-sm-10">
                      <template v-if="i.action.type == 'uri'">
                        <b-input
                          type="url"
                          class="form-control"
                          placeholder="請輸入完整網址，例如：https://www.google.com"
                          required
                          v-model="i.action.uri"
                          :state="!v$.$dirty || menuValidator.content.areas[idx].validUri ? null : false"
                          :disabled="isReadonly"
                        />
                        <b-form-invalid-feedback :state="!v$.$dirty || menuValidator.content.areas[idx].validUri ? null : false">
                          請填入正確連結
                        </b-form-invalid-feedback>
                      </template>
                      <template v-if="i.action.type == 'message'">
                        <b-input
                          type="text"
                          class="form-control"
                          placeholder="輸入文字"
                          required
                          v-model="i.action.text"
                          :state="!v$.$dirty || menuValidator.content.areas[idx].validText ? null : false"
                          :disabled="isReadonly"
                        />
                        <b-form-invalid-feedback
                          :state="!v$.$dirty || menuValidator.content.areas[idx].validText ? null : false"
                        >
                          請填入文字，且長度小於 300
                        </b-form-invalid-feedback>
                      </template>
                      <template v-if="i.action.type == 'richmenuswitch'">
                        <b-select v-model="i.action.data" :options="richMenus" :disabled="isReadonly">
                          <template #first>
                            <b-form-select-option :value="null" :disabled="isReadonly"
                              >-- 請選擇 --</b-form-select-option
                            >
                          </template>
                        </b-select>
                        <b-form-invalid-feedback :state="!v$.$dirty || menuValidator.content.areas[idx].validData ? null : false">
                          請選擇圖文選單
                        </b-form-invalid-feedback>
                      </template>
                      <template v-if="i.action.type == 'tel'">
                        <b-input
                          type="text"
                          class="form-control"
                          placeholder="輸入電話"
                          required
                          v-model="i.action.phoneNumber"
                          :state="!v$.$dirty || menuValidator.content.areas[idx].phoneNumber ? null : false"
                          :disabled="isReadonly"
                        />
                        <b-form-invalid-feedback :state="!v$.$dirty || menuValidator.content.areas[idx].phoneNumber ? null : false">
                          請填入電話
                        </b-form-invalid-feedback>
                      </template>
                    </div>
                  </div>
                  <div v-if="i.action.type == 'uri' || i.action.type == 'tel'" class="form-group row">
                    <label class="col-sm-2 col-form-label text-right">動作標籤</label>
                    <div class="col-sm-10">
                      <b-textarea
                        v-model="i.action.displayText"
                        rows="6"
                        placeholder="輸入動作標籤的說明"
                        :state="!v$.$dirty || menuValidator.content.areas[idx].validDisplayText ? null : false"
                        :disabled="isReadonly"
                      >
                      </b-textarea>
                      <b-form-invalid-feedback
                        :state="!v$.$dirty || menuValidator.content.areas[idx].validDisplayText ? null : false"
                      >
                        此欄位為必填
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>

          <div class="h5 mt-3">設定選單列</div>

          <div class="form-group row">
            <div class="col-sm-4 text-right">
              <label class="col-form-label d-block">選單列顯示文字</label>
              <small class="text-muted text-left">顯示於圖表下方顯示之文字</small>
            </div>
            <b-form-group class="col-sm-8" :disabled="isReadonly">
              <b-form-radio v-model="customChatbar" :value="false" @change="menu.content.chatBarText = '選單'">
                選單
              </b-form-radio>
              <div class="d-flex align-items-center">
                <b-form-radio
                  v-model="customChatbar"
                  :value="true"
                  class="text-nowrap mr-2"
                  @change="menu.content.chatBarText = ''"
                  >自訂文字</b-form-radio
                >
                <b-form-input
                  type="text"
                  class="form-control"
                  placeholder="自訂文字"
                  maxlength="14"
                  :disabled="!customChatbar || isReadonly"
                  v-model="menu.content.chatBarText"
                />
              </div>
            </b-form-group>
          </div>

          <div class="form-group row">
            <div class="col-sm-4 text-right">
              <label class="col-form-label d-block">預設顯示方式</label>
              <small class="text-muted text-left">進入官方帳號時是否顯示選單</small>
            </div>
            <b-form-group class="col-sm-8" :disabled="isReadonly">
              <b-form-radio v-model="menu.content.selected" :value="true" class="py-2">顯示</b-form-radio>
              <b-form-radio v-model="menu.content.selected" :value="false" class="py-2">隱藏</b-form-radio>
            </b-form-group>
          </div>
        </div>
      </div>

      <div class="d-flex">
        <div class="flex-fill d-flex justify-content-center">
          <b-button
            @click="handleCancel"
            variant="outline-danger"
            class="mr-3"
            >返回</b-button
          >
          <b-button
            v-if="!isReadonly"
            @click="save('')"
            variant="success"
            class="mr-3"
            >{{ saveTitle }}</b-button
          >
          <b-button
            v-if="showSaveAndSetSchedule"
            @click="save('set-schedule')"
            variant="success"
            class="mr-3"
            >預約上線</b-button
          >
          <b-button
            v-if="showSaveAndPublish"
            @click="save('publish')"
            variant="success"
            class="mr-3"
            >立即上線</b-button
          >
        </div>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import richMenuApi from "@/apis/richmenu";
import Datepicker from "vuejs-datepicker";
import { zh } from "vuejs-datepicker/dist/locale";
import format from "date-fns/format";
import VueTimepicker from "vue2-timepicker";
import _ from "lodash";
import useVuelidate from "@vuelidate/core";
import { required, helpers, requiredIf } from "@vuelidate/validators";
import ImageSelector from "@/components/ImageSelector";
import imageMixin from "@/mixins/uploadImage";
import { RICH_MENU_STATUS } from "@/consts";
import Preview from "@/components/Dashboard/OA/RichMenu/Preview";
import SpotlightHole from "@/components/SpotlightHole";
import { getErrorMessage, formatConflictMessage, RICHMENU_DEFAULT_CONFLICT } from "@/utils/errorCodes";
import {
  buildDefaultConflictHtml,
  filterConfirmedDefaultConflictWarnings,
  findOverlappingDefaultMenus,
  getDefaultMenuGapPeriods,
} from "@/utils/richMenuDefaultConflict";

const basicAction = {
  type: "uri",
  displayText: "",
  uri: "",
  richMenuAliasId: null,
};

const menuBigTemplate = [
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 600,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 300,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 300,
          y: 0,
          width: 300,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 600,
          y: 0,
          width: 300,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 300,
          width: 300,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 300,
          y: 300,
          width: 300,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 600,
          y: 300,
          width: 300,
          height: 300,
        },
      },
    ],
  },
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 600,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 450,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 450,
          y: 0,
          width: 450,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 300,
          width: 450,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 450,
          y: 300,
          width: 450,
          height: 300,
        },
      },
    ],
  },
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 600,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 900,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 300,
          width: 300,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 300,
          y: 300,
          width: 300,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 600,
          y: 300,
          width: 300,
          height: 300,
        },
      },
    ],
  },
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 600,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 600,
          height: 600,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 600,
          y: 0,
          width: 300,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 600,
          y: 300,
          width: 300,
          height: 300,
        },
      },
    ],
  },
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 600,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 900,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 300,
          width: 900,
          height: 300,
        },
      },
    ],
  },
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 600,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 450,
          height: 600,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 450,
          y: 0,
          width: 450,
          height: 600,
        },
      },
    ],
  },
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 600,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 900,
          height: 600,
        },
      },
    ],
  },
  {
    name: "custom",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 600,
    },
    areas: [],
  },
];

const menuBigTemplateAreasBounds = menuBigTemplate.map((template) =>
  JSON.stringify(template.areas.map((area) => area.bounds).sort())
);

const menuSmallTemplate = [
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 300,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 300,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 300,
          y: 0,
          width: 300,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 600,
          y: 0,
          width: 300,
          height: 300,
        },
      },
    ],
  },
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 300,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 300,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 300,
          y: 0,
          width: 600,
          height: 300,
        },
      },
    ],
  },
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 300,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 600,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 600,
          y: 0,
          width: 300,
          height: 300,
        },
      },
    ],
  },
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 300,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 450,
          height: 300,
        },
      },
      {
        action: _.clone(basicAction),
        bounds: {
          x: 450,
          y: 0,
          width: 450,
          height: 300,
        },
      },
    ],
  },
  {
    name: "",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 300,
    },
    areas: [
      {
        action: _.clone(basicAction),
        bounds: {
          x: 0,
          y: 0,
          width: 900,
          height: 300,
        },
      },
    ],
  },
  {
    name: "custom",
    chatBarText: "選單",
    selected: true,
    size: {
      width: 900,
      height: 300,
    },
    areas: [],
  },
];

const menuSmallTemplateAreasBounds = menuSmallTemplate.map((template) =>
  JSON.stringify(template.areas.map((area) => area.bounds).sort())
);

const isValidUrl = (urlString) => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)" + // validate protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
    "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

const actionValid = (value) => {
  switch (value.type) {
    case "uri":
      return (
        helpers.req(value.displayText) &&
        helpers.req(value.uri) &&
        isValidUrl(value.uri)
      );
    case "message":
      return helpers.req(value.text) && value.text.length <= 300;
    case "richmenuswitch":
      return helpers.req(value.data);
    case "tel":
      return helpers.req(value.phoneNumber);
    default:
      return false;
  }
};

export default {
  setup: () => ({ v$: useVuelidate() }),
  mixins: [imageMixin],
  components: { Datepicker, VueTimepicker, ImageSelector, Preview, SpotlightHole },
  validations() {
    const localRules = {
      menu: {
        title: {
          required: helpers.withMessage("請填寫標題", required),
        },
        start_at: {
          date: {
            required: helpers.withMessage("請填寫開始日期", required),
          },
          time: {
            HH: { required: helpers.withMessage("未填寫正確開始時間", required) },
            mm: { required: helpers.withMessage("未填寫正確開始時間", required) },
          },
        },
        end_at: {
          date: {
            required: helpers.withMessage("未填寫結束日期", required),
          },
          time: {
            HH: { required: helpers.withMessage("未填寫正確結束時間", required) },
            mm: { required: helpers.withMessage("未填寫正確結束時間", required) },
          },
        },
        content: {
          areas: {
            $each: helpers.forEach({
              action: { actionValid },
            }),
          },
        },
      },
      startAt: {},
      endAt: {
        minValue: helpers.withMessage('結束時間必須晚於開始時間', (value) => {
          if (!this.menu.start_at.date || !this.menu.end_at.date) return true;
          return value > this.startAt;
        }),
      },
      imageFile: {
        required: helpers.withMessage(
          '未上傳圖片',
          requiredIf(function () {
            return this.menu.image_url == null;
          })
        ),
      },
    };

    return localRules;
  },
  data() {
    return {
      isCustoming: false,
      showPreviewPopover: false,
      isLoading: false,
      zh,
      templateIndex: 0,
      menu: {
        title: "",
        start_at: {
          date: null,
          time: { HH: null, mm: null },
        },
        end_at: {
          date: null,
          time: { HH: null, mm: null },
        },
        is_default: false,
        image_url: null,
        outer_code: null,
        status: 0,
        content: null,
      },
      defaultConflictConfirmed: false,
      menuValidator: {},
      richMenus: [],
      menuBigTemplate: menuBigTemplate,
      menuSmallTemplate: menuSmallTemplate,
      customChatbar: false,
      imageFile: null,
      showCustomTemplateHint: false,
    };
  },

  computed: {
    ...mapGetters("route", ["routeQuery"]),
    startAt() {
      let startAt = new Date(this.menu.start_at.date);
      startAt.setHours(this.menu.start_at.time.HH);
      startAt.setMinutes(this.menu.start_at.time.mm);

      return `${format(startAt, "yyyy-MM-dd")}T${format(startAt, "HH:mm:ss")}`;
    },
    endAt() {
      let endAt = new Date(this.menu.end_at.date);
      endAt.setHours(this.menu.end_at.time.HH);
      endAt.setMinutes(this.menu.end_at.time.mm);

      return `${format(endAt, "yyyy-MM-dd")}T${format(endAt, "HH:mm:ss")}`;
    },
    title() {
      switch (this.$route.name) {
        case "RichMenuCreate":
          return "新增訊息";
        case "RichMenuShow":
          return "檢視訊息";
        case "RichMenuEdit":
          return "編輯訊息";
      }
      return "";
    },
    isReadonly() {
      return this.$route.name === "RichMenuShow";
    },
    isEditing() {
      return this.$route.name === "RichMenuEdit";
    },
    saveTitle() {
      return this.menu.status == RICH_MENU_STATUS.PUBLISHED || this.menu.status == RICH_MENU_STATUS.RESERVE
        ? "更新"
        : "儲存草稿";
    },
    showSaveAndSetSchedule() {
      return (
        !this.isReadonly &&
        this.menu.status == RICH_MENU_STATUS.DRAFT &&
        this.$permissions.has(this.$permissions.consts.LINE_MENU_MODIFY)
      );
    },
    showSaveAndPublish() {
      return (
        !this.isReadonly &&
        [RICH_MENU_STATUS.DRAFT, RICH_MENU_STATUS.RESERVE].includes(
          this.menu.status
        ) &&
        this.$permissions.has(this.$permissions.consts.LINE_MENU_MODIFY)
      );
    },
menuContentAreasBounds() {
      return JSON.stringify(this.menu.content.areas.map((area) => area.bounds).sort());
    },
    isCustomizedTemplate() {
      return !menuBigTemplateAreasBounds.includes(this.menuContentAreasBounds) &&
        !menuSmallTemplateAreasBounds.includes(this.menuContentAreasBounds)
    }
  },
  watch: {
    isCustoming(val) {
      this.showPreviewPopover = val;
    },
    menu: {
      handler() {
        this.updateMenuValidator();
      },
      deep: true,
    }
  },
  mounted() {
    if (this.$route.params.menuID) {
      this.fetchMenu();
    } else if (this.$route.query.copyFrom) {
      this.fetchMenuFromCopy();
    } else {
      this.menu.content = _.cloneDeep(menuBigTemplate[0]);
      this.templateIndex = 0;
    }
    this.fetchPublishRichMenus();
  },

  methods: {
    async fetchMenu() {
      this.isFetch = true;

      try {
        const { data } = await richMenuApi.getRichMenu(
          this.$route.params.menuID
        );

        this.setMenu(data);
      } catch (error) {
        console.log("error", error);
      }
      this.isFetch = false;
    },
    setMenu(data) {
      this.menu.title = data.data.title;
      this.menu.status = data.data.status;
      this.menu.is_default = data.data.is_default ?? false;

      const startAt = new Date(data.data.start_at);
      this.menu.start_at.date = startAt;
      this.menu.start_at.time.HH = format(startAt, "HH");
      this.menu.start_at.time.mm = format(startAt, "mm");

      const endAt = new Date(data.data.end_at);
      this.menu.end_at.date = endAt;
      this.menu.end_at.time.HH = format(endAt, "HH");
      this.menu.end_at.time.mm = format(endAt, "mm");

      this.menu.image_url = data.data.image_url;
      this.menu.content = data.data.content;
      //this.menu.is_selected = data.data.is_selected;
      //this.menu.chatbar_text = data.data.chatbar_text;

      this.menu.content.areas.forEach((area) => {
        if (area.action.type == "uri" && area.action.uri.startsWith("tel:")) {
          area.action.type = "tel";
        }
      });

      this.customChatbar = this.menu.content.chatBarText != "選單";
    },
    async fetchMenuFromCopy() {
      this.isFetch = true;

      try {
        const { data } = await richMenuApi.getRichMenu(
          this.$route.query.copyFrom
        );

        this.setMenu(data);
        this.menu.status = RICH_MENU_STATUS.DRAFT;
      } catch (error) {
        console.log("error", error);
      }
      this.isFetch = false;
    },
    async fetchPublishRichMenus() {
      const { data } = await richMenuApi.getRichMenus({
        statuses: [0, 1, 2],
        is_all: true,
      });
      this.richMenus = data.data.map((item) => {
        return {
          aliasId: item.alias_id,
          text: item.title,
          value: item.id,
        };
      });
    },

    switchTemplate(template, idx) {
      this.$swal({
        title: "您確定切換版型嗎？",
        text: "您的資料將不會儲存，是否確認切換？",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "確定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          this.templateIndex = idx;

          let temp = _.cloneDeep(template);

          temp.baseUrl = this.menu.content.baseUrl;

          this.menu.content = temp;

          //清除圖片
          // this.imageFile = this.menu.image_url = null;

          this.$bvModal.hide("modal-template");

          if (temp.name == "custom") {
            this.isCustoming = true;
          } else {
            this.isCustoming = false;
          }

          this.$refs.preview.clearCustomItems();
        } else {
          return;
        }
      });
    },

    selectImage(image) {
      this.imageFile = image;
    },

    shouldConfirmDefaultConflict(nextAction) {
      if (!this.menu.is_default) {
        return false;
      }

      if (["set-schedule", "publish"].includes(nextAction)) {
        return true;
      }

      return [RICH_MENU_STATUS.RESERVE, RICH_MENU_STATUS.PUBLISHED].includes(
        this.menu.status
      );
    },

    async checkScheduleOverlap(nextAction) {
      if (!this.shouldConfirmDefaultConflict(nextAction)) {
        return true;
      }

      try {
        const { data } = await richMenuApi.getRichMenus({
          statuses: [RICH_MENU_STATUS.RESERVE, RICH_MENU_STATUS.PUBLISHED],
          is_all: true,
        });

        const overlappingMenus = findOverlappingDefaultMenus({
          menus: data.data,
          currentMenuId: this.$route.params.menuID,
          startAt: this.startAt,
          endAt: this.endAt,
        });

        if (overlappingMenus.length > 0) {
          const gapPeriods = getDefaultMenuGapPeriods({
            affectedMenus: overlappingMenus,
            startAt: this.startAt,
            endAt: this.endAt,
          });
          const result = await this.$swal.fire({
            title: '<span style="color: #d9534f;">確認強制替換為此檔？</span>',
            html: buildDefaultConflictHtml({
              affectedMenus: overlappingMenus,
              gapPeriods,
            }),
            type: "warning",
            showCancelButton: true,
            cancelButtonText: "暫不異動",
            cancelButtonColor: "#d9534f",
            confirmButtonText: "確認覆蓋",
            confirmButtonColor: "#28a745",
            reverseButtons: true,
          });
          this.defaultConflictConfirmed = !!result.value;
          return this.defaultConflictConfirmed;
        }

        return true;
      } catch (error) {
        console.error("檢查時段重疊失敗:", error);
        // 發生錯誤時也阻擋操作
        await this.$swal.fire({
          title: "檢查失敗",
          text: "無法驗證時段衝突,請稍後再試。",
          icon: "error",
        });
        return false;
      }
    },

    async save(nextAction) {
      const isValid = await this.validate()
      if (!isValid) {
        return;
      }

      this.defaultConflictConfirmed = false;
      const noOverlap = await this.checkScheduleOverlap(nextAction);
      if (!noOverlap) return;

      const pass = await this.showConfirmSwal(nextAction);
      if (!pass) return;

      //Image
      if (this.imageFile) {
        const imgUrl = await this.uploadByBase64(this.imageFile);
        if (!imgUrl) {
          return;
        }
        this.menu.image_url = imgUrl;
      }

      let payload = _.cloneDeep(this.menu);

      payload.start_at = this.startAt;
      payload.end_at = this.endAt;
      payload.content.name = payload.title;
      payload.is_selected = this.menu.content.selected;
      payload.chatbar_text = this.menu.content.chatBarText;
      payload.content.areas.forEach((area) => {
        if (area.action.type == "richmenuswitch") {
          const richmenu = this.richMenus.find(
            (richmenu) => richmenu.value == area.action.data
          );
          area.action.richMenuAliasId = richmenu.aliasId;
        }
        if (area.action.type == "tel") {
          area.action.type = "uri";
          area.action.uri = `tel:${area.action.phoneNumber}`;
        }
      });
      payload.next_action = nextAction;

      // 編輯模式下，先進行驗證檢查
      if (this.isEditing) {
        const validatePass = await this.validateUpdateWarnings(payload, {
          defaultConflictConfirmed: this.defaultConflictConfirmed,
        });
        if (!validatePass) return;
      }

      try {
        this.isLoading = true;
        if (this.isEditing) {
          payload.id = this.$route.params.menuID;
          await richMenuApi.updateRichMenu(this.$route.params.menuID, payload);

          this.$swal("修改成功", "", "success");
        } else {
          await richMenuApi.createRichMenu(payload);

          this.$swal("新增成功", "", "success");
        }

        this.$router.push({
          name: "RichMenu",
          query: this.routeQuery,
        });
      } catch (error) {
        console.error(error);

        const { message, context, errorCode } = getErrorMessage(error);

        // 處理特定錯誤碼
        if (errorCode === RICHMENU_DEFAULT_CONFLICT && context?.conflicting_menus) {
          const conflictDetail = formatConflictMessage(context.conflicting_menus);
          this.$swal.fire({
            title: "預設選單衝突",
            type: "error",
            html: `${message}<br/><br/><strong>${conflictDetail}</strong><br/><br/>請先調整時段解決衝突`,
          });
        } else {
          this.$swal.fire({
            title: "錯誤",
            type: "error",
            text: message,
          });
        }

        if (error.response?.status === 422 && error.response?.data?.message) {
          this.validationErrors = error.response.data.message;
        }
      }
      this.isLoading = false;
    },
    async showConfirmSwal(action) {
      if (!action) return true;

      let confirmTitle, confirmMessage;

      if (action === "set-schedule") {
        const now = new Date();
        const startAt = new Date(this.startAt);
        const isTimeReached = startAt <= now;

        confirmTitle = isTimeReached ? "立即上線" : "預約上線";
        if (isTimeReached) {
          confirmMessage = `
            <div style="text-align: left;">
              <p style="color: #28a745;"><strong>※ 預約時間已到，將立即上線</strong></p>
              <br/>
              <p>是否確定將「${this.menu.title}」立即上線？</p>
            </div>
          `;
        } else {
          confirmMessage = `
            是否確定將「${this.menu.title}」預約上線？<br/>
            當預約時間到達後，選單將自動生效。
          `;
        }
      } else if (action === "publish") {
        confirmTitle = "立即上線";
        confirmMessage = `
          是否確定將「${this.menu.title}」立即上線？<br/>
          上線後，選單將自動生效。
        `;
      }

      const result = await this.$swal({
        title: confirmTitle,
        html: confirmMessage,
        type: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "確認",
        reverseButtons: true,
      });

      return result.value;
    },
    async validateUpdateWarnings(payload, { defaultConflictConfirmed = false } = {}) {
      try {
        const response = await richMenuApi.validateUpdate(this.$route.params.menuID, payload);

        // 後端可能將數據包在 data.data 或直接在 data 中
        const responseData = response.data.data || response.data;
        const warnings = filterConfirmedDefaultConflictWarnings({
          warnings: responseData.warnings || responseData,
          defaultConflictConfirmed,
        });
        const has_warnings = Array.isArray(warnings) ? warnings.length > 0 : false;

        if (!has_warnings) {
          return true;
        }

        // 建立警告訊息 HTML
        let warningMessages = warnings.map(warning => {
          switch (warning.type) {
            case 'default_conflict':
              return `<div class="warning-item">
                ${warning.message}：<br/>
                <span style="color: #d9534f;">「${warning.detail}」</span><br/><br/>
                預設選單 將調整為此檔 「${warning.current_title}」
              </div>`;

            case 'status_change_unpublished':
              return `<div class="warning-item">
                <strong>⚠️ 異動後的結束時間，是過去時間</strong><br/>
                您確定要異動，並將此選單下架嗎？
              </div>`;

            case 'status_change_reserve':
              return `<div class="warning-item">
                <strong>⚠️ 異動後的開始時間，是未來的時間</strong><br/>
                您確定要異動，並將此選單暫時下架，重新排程嗎？
              </div>`;

            default:
              return `<div class="warning-item">${warning.message}</div>`;
          }
        }).join('<br/><br/>');

        // 顯示確認對話框
        const result = await this.$swal({
          title: '確認變更',
          html: `
            <div style="text-align: left;">
              <p style="margin-bottom: 15px;">偵測到以下警告，確定要繼續嗎？</p>
              ${warningMessages}
            </div>
          `,
          type: 'warning',
          showConfirmButton: true,
          showCancelButton: true,
          cancelButtonText: '取消',
          confirmButtonColor: '#f0ad4e',
          confirmButtonText: '確認繼續',
          reverseButtons: true,
        });

        return result.value || false;
      } catch (error) {
        console.error('Validation error:', error);
        // 驗證失敗時，為了安全起見，允許繼續（避免阻擋正常操作）
        return true;
      }
    },
    customSave(areas) {
      this.menu.content.areas = areas;
      this.isCustoming = false;
    },
    handleCancel() {
      this.$router.push({
        name: "RichMenu",
        query: this.routeQuery,
      });
    },
    async validate() {

      const vuelidateOk = await this.v$.$validate();
      const menuErrors = this.validateMenu();

      
      if (!vuelidateOk || menuErrors.length > 0) {
        // 收集所有驗證錯誤訊息
        const errors = [];

        // 收集 vuelidate 的錯誤
        if (this.v$.$errors?.length) {
          this.v$.$errors.forEach((e) => e.$message && e.$property!='areas' && errors.push(e.$message));
        }

        const menuErrorsHtml = menuErrors.map(e => `${e.areaLabel}<ul class='m-auto text-left' style='width:fit-content;'>${e.messages.map(m => `<li>${m}</li>`).join("")}</ul>`)
        .join("");

        // 如果沒有具體錯誤訊息，使用預設訊息
        if (errors.length === 0) {
          errors.push("請確認所有訊息內容皆已填寫完整");
        }

        this.$swal.fire({
          title: "錯誤",
          type: "error",
          html: `${errors.join("<br/>")}<br/>${menuErrorsHtml}`,
        });
        return false
      }
      return true
    },
    validateMenu() {
      const areaErrors = [];
      //const areas = ["A", "B", "C", "D", "E", "F"];
      const menuAreas = this.menu?.content?.areas ?? [];
      const validatorAreas = this.menuValidator?.content?.areas ?? [];
      menuAreas.forEach((area, i) => {
        const action = area?.action ?? {};
        const actionValidator = validatorAreas[i] ?? {};
        const messages = [];
        if (action.type === "uri") {
          if (!actionValidator.validDisplayText) messages.push("未填寫動作標籤");
          if (!actionValidator.validUri) messages.push("未填寫網址");
        } else if (action.type === "message") {
          if (!actionValidator.validText) messages.push("未填寫文字");
        } else if (action.type === "richmenuswitch") {
          if (!actionValidator.validData) messages.push("未選擇圖文選單");
        } else if (action.type === "tel") {
          if (!actionValidator.validDisplayText) messages.push("未填寫動作標籤");
          if (!actionValidator.validPhoneNumber) messages.push("未填寫電話");
        }
        if (messages.length > 0) {
          areaErrors.push({
            areaLabel: `編輯欄位${String.fromCharCode(65 + i)}`,
            messages,
          });
        }
      });
      return areaErrors;
    },
    updateMenuValidator() {
      this.menuValidator = {
        content: {
          areas: this.menu.content.areas.map((area) => {
            const action = area.action;
            if (action.type === 'uri') {
              const validateDisplayText = () => !!action.displayText
              const validateUri = () => !!action.uri && isValidUrl(action.uri)
              return {
                displayText: action.displayText,
                validDisplayText: validateDisplayText(),
                uri: action.uri,
                validUri: validateUri()
              }
            } else if (action.type === 'message') {
              const validateText = () => !!action.text && action.text.length <= 300
              return {
                text: action.text,
                validText: validateText()
              }
            } else if (action.type === 'richmenuswitch') {
              const validateData = () => !!action.data
              return {
                data: action.data,
                validData: validateData()
              }
            } else if (action.type === 'tel') {
              const validateDisplayText = () => !!action.displayText
              const validatePhoneNumber = () => !!action.phoneNumber
              return {
                displayText: action.displayText,
                validDisplayText: validateDisplayText(),
                phoneNumber: action.phoneNumber,
                validPhoneNumber: validatePhoneNumber()
              }
            }
          })
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  opacity: 0.5;
}

.image-selector {
  .image {
    position: relative;
    width: 30%;
    button {
      position: absolute;
      top: -1rem;
      right: -1rem;
    }
  }
  .selector {
    width: 30%;
  }
}

#modal-template {
  .template {
    width: 24%;
    button {
      height: 100%;
      width: 100%;
      border-width: 1px !important;
      position: relative;

      .action {
        position: absolute;
        border-width: 1px !important;
      }
    }
    &.template-big {
      button {
        aspect-ratio: 3 / 2;
      }
    }

    &.template-small {
      button {
        aspect-ratio: 3 / 1;
      }
    }

    .hint-img {
      position: absolute;
      top: 50%;
      right: -32px;
      width: 24px;
      height: 24px;
      transform: translateY(-50%);
      cursor: pointer;
    }
  }
}

.card-header {
  .collapsed .fa::before {
    content: "\f054";
  }
  .not-collapsed .fa::before {
    content: "\f078";
  }
}

.preview-icon {
  width: 16px;
  height: 16px;
  margin: 4px 0;
  border: 2px solid var(--primary);
}

.preview-popover {
  $border-color: #777;
  $background-color: #fff;

  position: relative;
  padding: 8px 16px;
  background-color: $background-color;
  border: 2px solid $border-color;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(56, 56, 56, 0.5);

  .preview-popover__nub {
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid $border-color;

    &:after {
      content: '';
      position: absolute;
      top: -10px;
      left: -7px;
      width: 0;
      height: 0;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 7px solid $background-color;
    }
  }
}

.custom-preview-popover {
  display: grid;
  grid-template-columns: min-content auto;
  column-gap: 5px;
  row-gap: 4px;

  &>*:nth-child(odd) {
    justify-self: center;
  }
}

.close-button {
  position: absolute;
  top: -28px;
  right: -6px;
  background: transparent;
  border: none;
  font-size: 16px;
}
</style>

<style lang="scss">
#modal-template-custom-hint {
  .modal-dialog {
    max-width: 400px;
  }
}
</style>
